import * as React from 'react';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, withStyles, Theme, createStyles, TableBody, Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions } from '@material-ui/core';
import moment from 'moment'
import { listNotes, saveCoachingNotes } from '../../utils/api';
const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }),
)(TableCell);
const CoachingNotes = () => {

    const [notes, setNotes] = React.useState<Note[]>([])
    const [note, setNote] = React.useState<Note>({
        id: 0,
        create_time: 0,
        update_time: 0,
        client_name: '',
        content: '',
        coaching_id: '',
        coach_id: '',
        client_id: ''
    })
    const [show, setShow] = React.useState(false)

    const loadData = () => {
        listNotes().then(res => {
            setNotes(res.data)
        })
    }

    React.useEffect(() => {
        loadData()
    }, [])

    const handleShowNote = (n: Note) => () => {
        setNote(n)
        setShow(true)
    }

    const onNoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNote({ ...note, content: event.target.value })
    }

    const handleClose = () => {
        setShow(false)
        console.info(note.content)
        console.info(note.coaching_id)
        saveCoachingNotes(note.coaching_id,note.content,note.client_id).then(res=>{
            loadData()
        })
    }

    return <React.Fragment>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="center">来访者姓名</StyledTableCell>
                        <StyledTableCell align="center">创建时间</StyledTableCell>
                        <StyledTableCell align="center">最后修改时间</StyledTableCell>
                        <StyledTableCell align="center">笔记字数</StyledTableCell>
                        <StyledTableCell align="center">操作</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {notes.map(note => <TableRow key={note.id}>
                        <TableCell align="center">{note.client_name}</TableCell>
                        <TableCell align="center">{moment(note.create_time).format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                        <TableCell align="center">{moment(note.update_time).format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                        <TableCell align="center">{note.content.length}</TableCell>
                        <TableCell align="center">
                            <Button variant="text" onClick={handleShowNote(note)}>点击查看</Button>
                        </TableCell>
                    </TableRow>)}
                </TableBody>
            </Table>
        </TableContainer>

        <Dialog open={show} onClose={handleClose} maxWidth="md" >
            <DialogTitle>教练笔记(来访者:{note?.client_name})</DialogTitle>
            <DialogContent>
                <TextField style={{width: '600px'}} multiline rows={24} variant="outlined" autoFocus value={note?.content} onChange={onNoteChange} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    关闭
                </Button>
            </DialogActions>
        </Dialog>
    </React.Fragment>
}

export default CoachingNotes